module.exports = __webpack_public_path__ + "img/01-master-title.2429b8d2.png";